import React, { useMemo, useState } from 'react';

/** Small client-side sortable table for result sets the server returns in full.
 *  columns: [{ key, label, render?(row), value?(row), align?, sortable? }]. Empty values always sort last. */
export default function SortTable({ columns, rows, initial, rowKey, onRowClick, empty = 'Nothing to show for this selection.', note }) {
  const [sort, setSort] = useState(initial || null);
  const sorted = useMemo(() => {
    if (!sort) return rows;
    const col = columns.find((c) => c.key === sort.key);
    const get = (r) => (col.value ? col.value(r) : r[col.key]);
    return [...rows].sort((a, b) => {
      const x = get(a), y = get(b);
      if (x === null || x === undefined) return y === null || y === undefined ? 0 : 1;
      if (y === null || y === undefined) return -1;
      return (typeof x === 'string' ? x.localeCompare(y) : x - y) * sort.dir;
    });
  }, [rows, columns, sort]);
  const head = (c) => {
    const on = sort && sort.key === c.key;
    return (
      <th key={c.key} className={`${c.sortable === false ? '' : 'sortable'} ${c.align === 'right' ? 'r' : ''}`}
        aria-sort={on ? (sort.dir < 0 ? 'descending' : 'ascending') : undefined}
        onClick={c.sortable === false ? undefined : () => setSort({ key: c.key, dir: on ? -sort.dir : (c.align === 'right' ? -1 : 1) })}>
        {c.label}{on && <span className="arrow">{sort.dir < 0 ? '↓' : '↑'}</span>}
      </th>
    );
  };
  return (
    <>
      <div className="table-wrap">
        <table className="table">
          <thead><tr>{columns.map(head)}</tr></thead>
          <tbody>
            {sorted.map((r, i) => (
              <tr key={rowKey ? rowKey(r) : i} className={onRowClick ? 'clickable' : ''} onClick={onRowClick ? () => onRowClick(r) : undefined}>
                {columns.map((c) => <td key={c.key} className={c.align === 'right' ? 'r num' : ''}>{c.render ? c.render(r) : r[c.key] ?? '—'}</td>)}
              </tr>
            ))}
          </tbody>
        </table>
        {rows.length === 0 && <div className="empty"><strong>Nothing here</strong>{empty}</div>}
      </div>
      {note && <div className="pager"><span>{note}</span></div>}
    </>
  );
}
